import { render, staticRenderFns } from "./ModuleIdeaCreate.vue?vue&type=template&id=30b6125b&"
import script from "./ModuleIdeaCreate.vue?vue&type=script&lang=js&"
export * from "./ModuleIdeaCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModuleIdeaCreate.vue?vue&type=style&index=0&id=30b6125b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports